import {
  CircleQuestionSolid,
  CreditCardSolid,
  EnvelopeSolid,
  LocationDotSolid,
  RightFromBracketSolid,
  SignsPostSolid,
  UsersSolid,
} from '@allocab/allocab-icons';
import clsx from 'clsx';
import { useState } from 'react';

import { ModalContact } from './ModalContact';
import { NavItem, NavItemContent } from './NavItem';
import { useAuth } from '../../hooks/useAuth';
import { useFetchUser } from '../../hooks/useFetchUser';
import { t } from '../../services/translation/translation';

type Props = {
  navOpened: boolean;
  closeNav: () => void;
};

export const Nav = ({ navOpened, closeNav }: Props) => {
  const { data: user } = useFetchUser();
  const [isContactOpen, setIsContactOpen] = useState(false);
  const { logoutMutation } = useAuth();
  const onClose = () => setIsContactOpen(false);
  const closeNavigation = () => {
    closeNav();
    setIsContactOpen(false);
  };

  return (
    <>
      <div
        onClick={closeNavigation}
        className={`${navOpened ? 'fixed top-16 md:hidden bottom-0 right-0 left-0 bg-overlay z-50' : 'hidden'}`}
      />
      {isContactOpen ? <ModalContact onClose={onClose} /> : null}
      <nav
        className={clsx(
          'fixed top-16 left-0 transition-all duration-300 ease-in-out transform bg-background_highlight w-64 md:w-48 z-50',
          'peer-[.nav-closed]/header:hidden md:peer-[.nav-closed]/header:flex h-full',
        )}
      >
        <ul className="w-full">
          <NavItem
            className="border-t"
            to="/"
            icon={<LocationDotSolid width={16} height={16} className="mr-4" />}
            label={t('nav.home')}
            isContactOpen={isContactOpen}
            closeNavigation={closeNavigation}
          />
          {user?.admin ? (
            <NavItem
              className="border-t"
              to="/receptionists"
              icon={<UsersSolid width={16} height={16} className="mr-4" />}
              label={t('nav.receptionists')}
              isContactOpen={isContactOpen}
              closeNavigation={closeNavigation}
            />
          ) : null}
          <NavItem
            to="trips"
            icon={<SignsPostSolid width={16} height={16} className="mr-4" />}
            label={t('nav.trips')}
            isContactOpen={isContactOpen}
            closeNavigation={closeNavigation}
          />
          {user?.admin ? (
            <NavItem
              to="statistics"
              icon={<CreditCardSolid width={16} height={16} className="mr-4" />}
              label={t('nav.stats')}
              isContactOpen={isContactOpen}
              closeNavigation={closeNavigation}
            />
          ) : null}
          <li className="border-b">
            <div
              onClick={() => setIsContactOpen(!isContactOpen)}
              className={`${
                isContactOpen ? 'bg-background bg-opacity-30' : undefined
              } w-full py-4 px-2 inline-block cursor-pointer`}
            >
              <NavItemContent
                icon={<EnvelopeSolid width={16} height={16} className="mr-4" />}
                label={t('nav.contact-us')}
              />
            </div>
          </li>
          <li className="border-b">
            <a
              target="blank"
              href="https://help.allocab.com/hc/fr"
              className="w-full py-4 px-2 inline-block cursor-pointer"
            >
              <NavItemContent icon={<CircleQuestionSolid width={16} height={16} className="mr-4" />} label="FAQ" />
            </a>
          </li>
          <li className="border-b">
            <div onClick={() => logoutMutation.mutate()} className="w-full py-4 px-2 inline-block cursor-pointer">
              <NavItemContent
                icon={<RightFromBracketSolid width={16} height={16} className="mr-4" />}
                label={t('nav.logout')}
              />
            </div>
          </li>
        </ul>
      </nav>
    </>
  );
};
